"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_FOLDERS = exports.FOLDER_TYPE = void 0;
var FOLDER_TYPE;
(function (FOLDER_TYPE) {
    FOLDER_TYPE["DASHBOARD_FOLDER"] = "DASHBOARD_FOLDER";
    FOLDER_TYPE["DOCUMENT_FOLDER"] = "DOCUMENT_FOLDER";
})(FOLDER_TYPE || (exports.FOLDER_TYPE = FOLDER_TYPE = {}));
/**
 * Originally, folders were not identities stored separately with an id and other properties.
 * Those folders don't really exist in the db like the other ones. Their name is used to do the
 * link with other entities (ex: a dashboard in the folder "Recap" will have `{...,folder:"Recap",...}`
 * instead of a real id of a folder)
 */
var DEFAULT_FOLDERS;
(function (DEFAULT_FOLDERS) {
    DEFAULT_FOLDERS["SANITY_CHECK"] = "Sanity check";
    DEFAULT_FOLDERS["DATABASE"] = "Database";
    DEFAULT_FOLDERS["DEFAULT"] = "default";
    DEFAULT_FOLDERS["RECAP"] = "Recap";
    DEFAULT_FOLDERS["USAGE_MONITORING"] = "Usage Monitoring";
    DEFAULT_FOLDERS["HOME"] = "Home";
})(DEFAULT_FOLDERS || (exports.DEFAULT_FOLDERS = DEFAULT_FOLDERS = {}));
